import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {get,post} from './utils/request'
Vue.use(ElementUI, { size: 'small'});

Vue.prototype.$post = post;
Vue.prototype.$get = get;

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
